import { BASE_URL } from "../../Constant";

export const API_LOGIN: string = `${BASE_URL}/loginAdmin`;
export const API_LOGOUT: string = `${BASE_URL}/logout`;
export const API_USER_DETAILS: string = `${BASE_URL}/loggedInUserDetails`;

export const API_LOGIN_RESPONSE_SUCCESSFUL: string = 'SUCCESS';
export const API_LOGIN_RESPONSE_WRONG_CREDENTIALS: string = 'WRONG_CREDENTIALS';
export const API_LOGIN_RESPONSE_FAILED: string = 'FAILED';